import React, { useState } from 'react';
import { SiteComponent } from '../SiteComponentPlugin';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { IconButton, Icon, MenuItem, FormControlLabel, Checkbox, Menu } from '@material-ui/core';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { ConfigFieldControl, ConfigTextField, IconPicker } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
import { ComponentRenderer } from '../renderers';
export const SiteIconButton = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteIconButtonPlugin, props);
    const { icon, color, edge, size } = component.props || {};
    const [anchorEl, setAnchorEl] = useState(null);
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-button'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteIconButtonPlugin }, props),
        React.createElement(IconButton, Object.assign({ size: size, color: color, edge: edge, onClick: handleMenuClick, className: classes.join(' ') }, hoverProps(component)), React.createElement(Icon, null, icon)),
        anchorEl && component.children && (React.createElement(Menu, { id: 'icon-button-menu', anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: e => setAnchorEl(null), getContentAnchorEl: null, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right'
            } }, (_a = component.children) === null || _a === void 0 ? void 0 : _a.map(child => (React.createElement(ComponentRenderer, { key: child.id, component: child })))))));
};
export const SiteIconButtonConfigurator = props => {
    var _a, _b, _c, _d, _e, _f;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(IconPicker, { value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.icon) || '', onChange: icon => {
                    update('props.icon', icon);
                } }),
            "Icon"),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Color', value: ((_b = component.props) === null || _b === void 0 ? void 0 : _b.color) || '', onChange: event => {
                    update('props.color', event.target.value);
                } }, ['default', 'inherit', 'primary', 'secondary'].map(color => (React.createElement(MenuItem, { key: color, value: color }, color))))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Size', value: ((_c = component.props) === null || _c === void 0 ? void 0 : _c.size) || '', onChange: event => {
                    update('props.size', event.target.value);
                } }, ['small', 'medium'].map(sizes => (React.createElement(MenuItem, { key: sizes, value: sizes }, sizes))))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Edge', value: `${(_d = component.props) === null || _d === void 0 ? void 0 : _d.edge}` || '', onChange: event => {
                    if (event.target.value === 'false') {
                        update('props.edge', false);
                    }
                    else
                        update('props.edge', event.target.value);
                } }, ['start', 'end', 'false'].map(edge => (React.createElement(MenuItem, { key: edge, value: edge }, edge))))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(FormControlLabel, { label: 'Attach Dropdown Menu', control: React.createElement(Checkbox, { color: 'primary', size: 'small', className: 'checkbox', checked: Boolean((_e = component.props) === null || _e === void 0 ? void 0 : _e.attachDropDownMenu), onChange: () => {
                        var _a;
                        update('props.attachDropDownMenu', !((_a = component.props) === null || _a === void 0 ? void 0 : _a.attachDropDownMenu));
                    } }) })),
        ((_f = component.props) === null || _f === void 0 ? void 0 : _f.attachDropDownMenu) && (React.createElement(SiteComponentStackConfigurator, { component: props.component }))));
};
export const SiteIconButtonPlugin = {
    name: 'IconButton',
    type: 'icon-button',
    component: SiteIconButton,
    configurator: SiteIconButtonConfigurator,
    initConfig: component => {
        if (!component.props)
            component.props = {};
        component.props.icon = 'help_outline';
        component.props.color = 'inherit';
        component.props.size = 'small';
        return component;
    }
};
//# sourceMappingURL=SiteIconButtonPlugin.js.map